import { motion } from 'framer-motion';
import { CurrencyDollarIcon, HomeModernIcon, BanknotesIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const icons = {
  'Hold RENT Tokens': CurrencyDollarIcon,
  'Property Management': HomeModernIcon,
  'Earn Passive Income': BanknotesIcon,
  'Portfolio Growth': ChartBarIcon
};

interface StepCardProps {
  title: string;
  description: string;
  index: number;
}

export default function StepCard({ title, description, index }: StepCardProps) {
  const Icon = icons[title as keyof typeof icons];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group h-full"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-primary-dark/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg -m-2 p-2 blur-xl"></div>
      <div className="relative h-full bg-white rounded-lg shadow-lg p-6 border border-gray-100 transition-transform duration-300 group-hover:-translate-y-1">
        <div className="bg-secondary w-12 h-12 rounded-lg p-2.5 mb-4 shrink-0">
          <Icon className="w-full h-full text-white" />
        </div>
        <h4 className="text-gray-900 mb-3 font-kanit text-[22px] leading-[36px]">{title}</h4>
        <p className="text-body text-gray-600">{description}</p>
      </div>
    </motion.div>
  );
}